module.exports = __webpack_public_path__ + "static/media/learninglogo.953bf372.png";